<template>
  <div class="contact">
    <main class="contact-container">
      <gradient-title class="title" text="Kontakt" />

      <div class="contact-content">
        <p class="description">
          Du hast ein Projekt im Kopf oder möchtest mit mir zusammenarbeiten? Ich freue mich auf deine Nachricht!
        </p>

        <form name="contact" class="contact-form" method="POST" data-netlify="true" action="/" netlify-honeypot="bot-field">
          <input type="hidden" name="form-name" value="contact" />
          <input name="bot-field" style="display: none;" />

          <div class="form-group">
            <label for="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              required
            />
          </div>

          <div class="form-group">
            <label for="email">E-Mail</label>
            <input
              type="email"
              id="email"
              name="email"
              required
            />
          </div>

          <div class="form-group">
            <label for="subject">Betreff</label>
            <input
              type="text"
              id="subject"
              name="subject"
              required
            />
          </div>

          <div class="form-group">
            <label for="message">Nachricht</label>
            <textarea
              id="message"
              name="message"
              rows="6"
              required
            ></textarea>
          </div>

          <div class="form-group checkbox-group">
            <label class="checkbox-label">
              <input
                type="checkbox"
                name="privacy-consent"
                v-model="privacyConsent"
                required
              />
              Ich stimme der Verarbeitung meiner Daten gemäß der
              <router-link to="/datenschutz" class="privacy-link">Datenschutzerklärung</router-link> zu.
            </label>
          </div>

          <gradient-button type="submit" :disabled="!privacyConsent">
            Nachricht senden
          </gradient-button>
        </form>

      </div>
    </main>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import GradientTitle from "@/components/GradientTitle.vue";
import GradientButton from "@/components/GradientButton.vue";

const privacyConsent = ref(false)
</script>

<style scoped>
.contact {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  min-height: calc(100vh - 120px);
}

.contact-container {
  max-width: 600px;
  width: 100%;
}

.title {
  text-align: center;
}

.description {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #555;
  text-align: center;
  margin-bottom: 2rem;
}

.contact-form {
  background: #ffffff;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border: 1px solid #e1e8ed;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.5rem;
  font-size: 0.95rem;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 2px solid #e1e8ed;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  font-family: inherit;
}

.form-group input:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #00d1b2;
  box-shadow: 0 0 0 3px rgba(0, 209, 178, 0.1);
}

.form-group textarea {
  resize: vertical;
  min-height: 120px;
}

.checkbox-group {
  margin-bottom: 2rem;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
  cursor: pointer;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  flex-shrink: 0;
  vertical-align: top;
  margin: 0 8px 0 0;
}

.privacy-link {
  color: #00d1b2;
  text-decoration: none;
  transition: color 0.2s ease;
}

.privacy-link:hover {
  color: #00b8a3;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .contact {
    padding: 1rem;
  }

  .contact-form {
    padding: 1.5rem;
  }

  .description {
    font-size: 1rem;
  }
}
</style>
